import {fetchMetaDataApi, uploadFileApi, exportToExcelFileDailyRevenueApi, fetchRemarksOptionsApi} from '../../services/common-api';
import {fetchDailyRevenueDetailsApi, submitDailyRevenueDetailsApi, fetchStatuswiseRevenueDatesApi, 
        submitSelectedDailyRevenueDetailsApi, submitUnblockContractRequestApi} from '../../services/business-partner-api';

export const fetchMetaData = () => {
    return fetchMetaDataApi(1);
}

export const fetchDailyRevenueDetails = (bpCode, revenueDate,startDate, endDate, isWeekly) => {
    return fetchDailyRevenueDetailsApi(bpCode, revenueDate,startDate, endDate, isWeekly);
}

export const submitDailyRevenueDetails = (revenueData, revenueDate, submittedBy, isChangeRequest, isWeekly) => {
    return submitDailyRevenueDetailsApi(revenueData, revenueDate, submittedBy, isChangeRequest, isWeekly);
}

export const importFromExcel = (selectedFile, bpCode, revenueDate, startDate, endDate, selectedLangId, isWeekly) => {
    return uploadFileApi(selectedFile, bpCode, revenueDate, startDate, endDate, selectedLangId, isWeekly);
}

export const exportToExcel = (bpCode, revenueDate, startDate, endDate, selectedLangId, isWeekly) => {
    return exportToExcelFileDailyRevenueApi(bpCode, revenueDate, startDate, endDate, selectedLangId, isWeekly);
}

export const fetchStatuswiseRevenueDates = (minDate, maxDate, bpCode) => {
    return fetchStatuswiseRevenueDatesApi(minDate, maxDate, bpCode);
}

export const fetchRemarksOptions = () => {
    return fetchRemarksOptionsApi();
}

export const submitSelectedDailyRevenueDetails = (selectedUnsubmittedRevenues, revenueDate, submittedBy, isWeekly) => {
    return submitSelectedDailyRevenueDetailsApi(selectedUnsubmittedRevenues, revenueDate, submittedBy, isWeekly);
}

export const submitUnblockContractRequest = (unblockRequestData) => {
    return submitUnblockContractRequestApi(unblockRequestData);
}

